export default "__VITE_ASSET__C7nWjQ2c__"